import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { StyledModal,CalendarHeader,Border } from '../Rewards/styles';
import {
  InputContainer,
  StyledInputV2,
  StyledLabel,
  UploadPhotoContainer,
} from '../../CreateEvent/style';
import { withRouter } from 'react-router-dom';
import { CommonButtonPopup } from '../../ReportsV2/styles';
// import { CommonButtonBorder } from '../../common/commonStyles';
import { AdminCloseIcon, DeleteIconBranding, TicIcon, UploadHDMIcon, closeIcon } from '../../../utils/icons';
import { toast } from 'react-toastify';
import { UploadDocumentContainer } from './styles';
import CommonImageUploader from '../../common/CommonImageUploader/CommonImageUploader';
import { t } from 'i18next';
import { fetchApi } from '../../../utils/methods';
import { UploadCompanyAdminRewardDocuments } from '../../../redux/constants/apiConstants';
import { ImageUrl } from '../../../utils/constants';
import { showSuccessToast } from '../../UserDashboard/ToastHelper';
import { connect } from 'react-redux';


const UploadDocumentModal = ({
  show,
  icon,
  title,
  onCancel,
  modalWidth = "500px",
  modalHeight,
  onClose,
  //   onConfirm,
  //   history,
  companyInfo,
  fetchDocuments,
  selectedDoc,
  firstName
}) =>{

  const[documentDetails,setDocumentDetails] = useState(null);
  const[documentName,setDocumentName] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(()=>{

    if(selectedDoc){
      manipulateSelectedDocData()
    }

  },[])

  const manipulateSelectedDocData= ()=>{
    setDocumentDetails({thumbnailSrc:selectedDoc?.document_image,documentName:selectedDoc?.document,documentSrc:selectedDoc?.document});
    setDocumentName(selectedDoc?.title)
  }

  const onChange = (e) => {
    const file = e.target.files[0];
  
    if (file) {
      if (file.size / 1000000 <= 20) {
        setDocumentDetails({
          ...documentDetails,
          documentFile: file,
          documentName: file.name
        });
      } else {
        toast.error("Please select file less than 20MB");
        e.target.value = "";
      }
    }
  };
  

  const onThumbnailChange = (baseImage, imageName,_, file) => {
    setDocumentDetails({...documentDetails, thumbnailSrc:baseImage,thumbnailName:imageName,thumbnailFile:file})
  }

  const onThumbnailRemove = () => {
    setDocumentDetails({...documentDetails, thumbnailSrc:null,thumbnailName:null,thumbnailFile:null})
  };

  const onDocumentRemove = () => {
    setDocumentDetails({...documentDetails, documentSrc:null,documentName:null,documentFile:null})
  };

  const uploadDocument = async () => {
    setLoading(true);
  
    try {
  
      let response;
  
      if (selectedDoc) {
  
        /* ---------- EDIT (NORMAL JSON) ---------- */
  
        const payload = {
          document_id: selectedDoc.id,
          title: documentName,
          thumbnail: documentDetails.thumbnailSrc,
        };
  
        response = await fetchApi(
          UploadCompanyAdminRewardDocuments,
          "PUT",
          payload
        );
  
      } else {
  
        /* ---------- UPLOAD (MULTIPART) ---------- */
  
        const formData = new window.FormData();
  
        formData.append("company_id", companyInfo?.id);
        formData.append("title", documentName);
        formData.append("thumbnail", documentDetails?.thumbnailSrc);
  
        if (documentDetails?.documentFile) {
          formData.append("document", documentDetails.documentFile);
        }
  
        response = await fetchApi(
          UploadCompanyAdminRewardDocuments,
          "POST",
          formData
        );
  
      }
  
      if (response.status === "success") {
        // toast.success(response?.message);
        showSuccessToast('Document Uploaded Successfully!',`Hi, ${firstName} ${documentName} document is uploaded successfully!`);
        fetchDocuments();
        onClose();
      } else {
        toast.error(response?.data?.message);
      }
  
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };
  

  const checkBase64 = (image)=> {
    if(image) {
      let arr = image.split('/');
      if(arr[0] !== 'company-rewards-thumbnails') {
        return true;
      }
      else {
        return false;
      }
    }
  }

  const SelectPointTierLevels = () => {
    window.console.log("hihi");
    
    return (
      <>
        {/* <div>Select Month To Start Your Rewards It will default to 12 month</div> */}
        <InputContainer >
          <StyledLabel isFont="16px" color="#184A61" margin={'0px'}>
            {'Name Document'} <span>*</span>
          </StyledLabel> 

          <StyledInputV2
            placeholder={`Enter document name`}
            value={documentName}
            onChange={(e) => setDocumentName(e.target.value)}
            bgColor="white"
            border="1px solid #BDBDBD"
            color="#184A61"
            // disabled
          />
        </InputContainer>

        <StyledLabel isFont={"14px"} color={"#184A61"} margin="20px" marginb="12px" symbolSize={"14px"}>{"Add Doc Thumbnail"}{<span>*</span>}</StyledLabel>
        <CommonImageUploader
          imgSrc={checkBase64(documentDetails?.thumbnailSrc) ? documentDetails?.thumbnailSrc : documentDetails?.thumbnailSrc ? `${ImageUrl}/${documentDetails?.thumbnailSrc}` : null}
          t={t}
          closeIcon={closeIcon}
          UploadIcon={UploadHDMIcon}
          onImageChange={onThumbnailChange}
          onRemoveImage={onThumbnailRemove}
          showBorder={true}
          // disabled={isCustomizedEvent}
        />


        {selectedDoc ?         <InputContainer style={{marginTop:'20px'}}> 

          <StyledInputV2
            placeholder={`Enter document name`}
            value={documentDetails?.documentName}
            onChange={(e) => setDocumentName(e.target.value)}
            bgColor="white"
            border="1px solid #BDBDBD"
            color="#184A61"
            disabled
          />
        </InputContainer> :  <UploadDocumentContainer>
          <UploadPhotoContainer style={{marginTop:'20px'}}>
            <div>
              {documentDetails?.documentSrc ? (
                <div className="doc-container"><div className="doc-text">{documentDetails?.documentName}</div><div className="delete-icon" onClick={()=>onDocumentRemove()}>{DeleteIconBranding()}</div></div>
              ) : (
                <div className="middle-section">
                  <label htmlFor="event-upload-file" className="custom-upload-button">
                    {UploadHDMIcon(16, 20)}
                    <span className="text">{"Upload Document"}</span>
                  </label>
                  <input
                    id="event-upload-file"
                    type="file"
                    name="user"
                    accept=".pdf, .doc, .docx, .csv, .xls, .xlsx, .jpeg, .png, .jpg"
                    multiple={false}
                    onChange={(e) => onChange(e)}
                    onClick={(e) => e.target.files[0] && onChange(e)}
                  />
                </div>
              )}
            </div>
            <StyledLabel isFont={"16px"} color={"#7C7C7C"} margin="12px" marginb="0px" symbolSize={"14px"}>{"(pdf, png, doc, docx, jpeg, csv, xls, xlsx)"}</StyledLabel>
          </UploadPhotoContainer>
        </UploadDocumentContainer>}
      </>
    );
  };
      
    
    
  return(
    <StyledModal show={show} width={modalWidth} height={modalHeight}>
      <div className="modal-content-padding">
        <CalendarHeader>
          <div className="left-content">
            <div className="icon">{icon && icon}</div>
            <div>{title}</div>
          </div>
          <div className="close-icon" onClick={()=>onClose ? onClose() :onCancel()}>
            {AdminCloseIcon()}
          </div>
        </CalendarHeader>
        <Border/>
  
      </div>

      <div className='modal-body'>

        {/* {loading ?
          <Grid>
            {Array.from({ length: 3 }).map((_, index) => (
              <SkeletonLoder
                key={index}
                width="285px"
                height="387px"
                style={{ gap: "25px" }}
              />
            ))}
          </Grid> : SelectPointTierLevels()} */}

        {SelectPointTierLevels()}
      </div>


  
      <div className='footer'>
        <CommonButtonPopup height="48px" width="100%" disabled={loading || !documentName || (!selectedDoc && !documentDetails?.documentFile) || !documentDetails?.thumbnailSrc} onClick={() => uploadDocument()}>
          {TicIcon(loading || !documentName || (!selectedDoc && !documentDetails?.documentFile) || !documentDetails?.thumbnailSrc ? '#989898' : 'white')} Done
        </CommonButtonPopup>
  
      </div>
    </StyledModal>
  )};


UploadDocumentModal.propTypes = {
  show: PropTypes.bool.isRequired,
  title:PropTypes.string, 
  onCancel: PropTypes.func.isRequired,
  modalWidth: PropTypes.string,
  modalHeight: PropTypes.string,
  icon: PropTypes.node.isRequired, 
  onClose:PropTypes.func,
  history:PropTypes.object,
  companyInfo:PropTypes.object,
  onConfirm:PropTypes.func,
  fetchDocuments:PropTypes.func,
  selectedDoc:PropTypes.string,
  firstName:PropTypes.string
};

const mapStateToProps = (state) => ({
  firstName: state.profileData.firstName,
})



export default withRouter(connect(mapStateToProps, null)(UploadDocumentModal));
  
